<template>
  <v-col cols="2" :class="'mobile-display-none text-center vh fixed '+ side" no-gutters>
      <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "SidePageColumn",
  props: {
    side: {
      type: String,
      default: "left"
    }
  }
};
</script>